import { useContext } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
    Colors,
    MediaQueries,
    Spacing
} from "@paclife/plds.tokens";

import { SSO_SUPPRESSION } from "constants/index"
import { AppContext } from "context/AppContext";
import formatSsaRole from "utils/formatters/ssaRole";
import PersonalIcon from "assets/svg/personal.svg";
import Card from "common/Card/Card";
import Typography from "common/Typography/Typography";

const CustomGrid = styled.div`
    display: grid;
    @media (min-width: ${MediaQueries.md}) {
        grid-template-columns: repeat(3, minmax(150px, 1fr));
    }
    gap: 24px;
    margin-bottom: ${Spacing[24]};
`;

const LabelText = styled(Typography)`
    color: ${Colors.textBodyLight};
    margin-bottom: ${Spacing[4]};
`;

const Image = styled.img`
    width: 120px;
    grid-column: 3 / 4;
    grid-row: 1 / 3;
    justify-self: center;
    @media (max-width: ${MediaQueries.lg}) {
        display: none;
    }
`;

const FIELDS = [
    "username",
    "repCrd",
    "firmName",
    "firmId",
    "plAgentId",
    "dealer",
    "agency",
    "agentId",
    "lastLogin",
    "userRole" 
];

const AboutMe = () => {
    const { t } = useTranslation("aboutMe");
    const { personal, userSession } = useContext(AppContext);
    const ssoUser = userSession.data?.user?.ssoUser;
    const userRole = userSession.data?.user?.userRole;
    const ssaRoles = ["ssa_consultant", "ssa_casemanager"];
    const isSsa = ssaRoles.includes(userRole);

    return (
        <Card title={t("title")}>
            <CustomGrid>
                {FIELDS.map((field) => {

                    if (ssoUser && SSO_SUPPRESSION.includes(field)) {
                        return null;
                    }

                    if (field === "userRole" && !isSsa) {
                        return null; // Hide user role for non SSA users       
                    }
                    
                    if (field !== "userRole" && !personal[field]) {
                        return null;
                    }

                    return (
                        <div key={field}>
                            <LabelText variant="caption" display="block" bold>
                                {t(field)}
                            </LabelText>
                            <Typography variant="body">
                                { field === "userRole" ? formatSsaRole(userRole) : personal[field] }
                            </Typography>
                        </div>
                    );
                })}
                <Image src={PersonalIcon} alt="personal icon image" />
            </CustomGrid>
        </Card>
    );
};

export default AboutMe;

AboutMe.propTypes = {
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
        })
    ).isRequired
};
